import { Components } from '../../material';

export const MuiDrawer: Components['MuiDrawer'] = {
  styleOverrides: {},
  defaultProps: {
    anchor: 'right',
  },
};
